<template>
    <!-- Modal -->
    <div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
            <div class="modal-content" v-if="documento || idGuias">
                <div class="modal-header">
                    <h5 class="modal-title">IpSign - Selecione o meio de assinatura</h5>
                    <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <div class="progress mt-1 mb-2" v-if="$store.state.loading">
                        <div class="indeterminate" v-if="$store.state.loading"></div>
                    </div>

                    <template>
                       <az-input
                            placeholder="Selecione o meio de assinatura"
                            label="Selecione o meio de assinatura"
                            type="select"
                            :optionsList="[
                                {
                                    'id': 'dispositivo',
                                    'nome': 'Dispositivo',
                                },
                                {
                                    'id': 'email',
                                    'nome': 'E-mail / Link',
                                },
                            ]"
                            optionsDisplay="nome"
                            optionsData="id"
                            :edicao="!link"
                            v-model="meio" />

                        <az-input
                            class="mt-1"
                            label="Obter link para envio"
                            type="checkbox-group"
                            v-if="meio == 'email' && !idGuias"
                            :edicao="!link"
                            v-model="obter_link" />

                       <az-input
                            placeholder="Selecione o dispositivo"
                            label="Selecione o dispositivo"
                            type="select"
                            :optionsList="dispositivos"
                            optionsDisplay="nome"
                            optionsData="id"
                            v-model="dispositivo"
                            :edicao="meio == 'dispositivo'"
                            v-if="meio && meio == 'dispositivo'" />

                        <template v-else>

                            <az-input
                                placeholder="E-mail"
                                label="Informe o e-mail"
                                type="email"
                                v-model="email"
                                :validate="validate" />

                        </template>

                       <az-input
                            placeholder="cpf"
                            label="Informe o cpf"
                            type="cpf"
                            :edicao="!link"
                            v-model="cpf" />

                       <az-input
                            placeholder="Nome"
                            label="Nome"
                            :edicao="!link"
                            v-model="nome" />

                        <template v-if="link">
                            <div class="alert alert-info mt-3 mb-0 d-flex justify-content-between">
                                <div>Link para Assinatura</div>
                                <div>
                                    <a href="#" @click.prevent="copiar_clipboard()" title="Copiar link.">
                                        <i class="fa-solid fa-copy"></i>
                                    </a>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="fechar_modal()">
                        Fechar
                    </button>
                    <az-submit @click="assinar()" :disabled="link">Assinar</az-submit>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
// import _ from "lodash";
import AzInput from "../shared/forms/AzInput.vue";
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() {
        return {
            documento: null,
            dispositivos: null,
            dispositivo: null,
            meio: 'dispositivo',
            email: null,
            cpf: null,
            nome: null,
            dt_nascimento: null, 
            nomeArquivo: null,
            unidade: "",
            operadora: "",
            chave_assinatura: "",
            qtd_ocor_ass: 0,
            obter_link: false, 
            link: null, 
            validate: false, 
            idGuias: null,
            uuidModal: null,
            other_model_id : null,
            other_model_type : null,
            other_id_atendimento : null,
        };
    },

    props: ['model_id', 'model_type', 'id_modelo_documento'],

    components: {
        AzInput,
        AzSubmit
    },

    computed: {
        modal_id: function () {
            return 'ipsignModal' + this.uuidModal;
        },
    },

    methods: {
        fechar_modal() { 
            $("#" + this.modal_id).modal("hide");
        },

        copiar_clipboard () { 
            this.$util.copiar_clipboard(
                this, 
                this.link,
                'Link copiado.'
            );
        },

        load() {
            this.dispositivos = [];

            this.$util.load(this, {
                service: "ipsign",
                func: "dispositiivos",
                redir_api: true, 
                parms: {
                    model_type: this.model_type,
                    model_id: this.model_id,
                },
                toast: false,
                loadTo: res => {
                    if(res && res.length) {
                        this.dispositivos = res;
                    }
                }
            });

            this.dispositivo = this.$util.getCookie('dispositivo-ipsign');
        },

        show(documentoBase64, nomeArquivo, email, cpf, nome, unidade = "", operadora = "", chave_assinatura = "", qtd_ocor_ass = 0, dt_nascimento = "", model_id = null, model_type = null, id_atendimento = null) {
            this.validate = false;

            this.load();

            if(nomeArquivo && nomeArquivo != '') {
                this.nomeArquivo = nomeArquivo.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            } else {
                this.nomeArquivo = 'documento_ipsign';
            }

            this.documento = documentoBase64;
            this.email = email;
            this.cpf = cpf;
            this.nome = nome;
            this.dt_nascimento = dt_nascimento;
            this.unidade = unidade;
            this.operadora = operadora;
            this.chave_assinatura = chave_assinatura;
            this.qtd_ocor_ass = qtd_ocor_ass;
            this.link = "";

            if (model_id && model_type) {
                this.other_model_id = model_id;
                this.other_model_type = model_type;
                this.other_id_atendimento = id_atendimento;
            }
            
            $("#" + this.modal_id).modal("show");
        },
        
        show_guias(idGuias, email, cpf, nome, unidade = "", operadora = "", chave_assinatura = "", qtd_ocor_ass = 0, dt_nascimento = "") {
            this.validate = false;

            this.load();
            
            this.documento = '';
            this.nomeArquivo = 'guia_ipsign';
            this.idGuias = idGuias

            this.email = email;
            this.cpf = cpf;
            this.nome = nome;
            this.dt_nascimento = dt_nascimento;
            this.unidade = unidade;
            this.operadora = operadora;
            this.chave_assinatura = chave_assinatura;
            this.qtd_ocor_ass = qtd_ocor_ass;
            this.link = "";

            $("#" + this.modal_id).modal("show");
        },

        assinar() {
            this.$util.setCookie('dispositivo-ipsign', this.dispositivo);

            this.$util.atualizar(this, {
                service: "ipsign",
                func: "assinar",
                redir_api: true, 
                dados: {
                    model_id: this.other_model_id ? this.other_model_id : this.model_id,
                    model_type: this.other_model_type ? this.other_model_type : this.model_type,
                    pdf: this.documento,
                    nome_arquivo: this.nomeArquivo,
                    meio: this.meio,
                    id_dispositivo: this.dispositivo,
                    email: this.email,
                    cpf: this.cpf,
                    nome: this.nome,
                    dt_nascimento: this.dt_nascimento, 
                    unidade: this.unidade,
                    operadora: this.operadora,
                    chave_assinatura: this.chave_assinatura,
                    qtd_ocor_ass: this.qtd_ocor_ass,
                    id_modelo_documento: this.id_modelo_documento,
                    obter_link: this.obter_link, 
                    id_guias: this.idGuias,
                    id_atendimento : this.other_id_atendimento
                },
                toast: false,
                callback: res => {
                    if(res && res.status_code == 200) {
                        this.$toast.add({
                            severity: "success",
                            summary: "Atualizar",
                            detail: res.msg ? res.msg : "Documento enviado com sucesso",
                            life: 3000
                        });

                        if ( this.meio == 'email' && this.obter_link ) { 
                            this.link = res.link;
                            return;
                        }
                    }

                    $("#" + this.modal_id).modal("hide");
                }
            });
        }
    },
    
    mounted() {
        const uuid = this.$util.uuidv4();
        this.uuidModal = uuid;
    },

};
</script>